import { App } from '@/interfaces';
import { AppsState } from './state';
import { getStoreAccessors } from 'typesafe-vuex';
import { State } from '../state';

export const mutations = {
  setMyApps(state: AppsState, payload: App[]) {
    state.apps = payload.sort((a, b) => a.name.localeCompare(b.name));
  },
};

const { commit } = getStoreAccessors<AppsState, State>('');

export const commitSetMyApps = commit(mutations.setMyApps);
